import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Sidebar = ({ isCollapsed = false }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    {
      label: 'قائمة الانتظار',
      path: '/admin/dashboard',
      icon: 'Inbox',
      tooltip: 'قائمة المقالات المعلقة'
    },
    {
      label: 'الأرشيف',
      path: '/admin/archive',
      icon: 'Archive',
      tooltip: 'القرارات السابقة'
    },
    {
      label: 'الإعدادات',
      path: '/admin/settings',
      icon: 'Settings',
      tooltip: 'إعدادات النظام'
    }
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <>
      <button
        onClick={toggleMobileMenu}
        className="fixed top-4 right-4 z-50 lg:hidden bg-card p-3 rounded-lg shadow-warm transition-default hover:shadow-warm-md"
        aria-label="Toggle navigation menu"
      >
        <Icon name={isMobileOpen ? 'X' : 'Menu'} size={24} color="var(--color-foreground)" />
      </button>
      <aside
        className={`fixed lg:fixed top-0 right-0 h-full bg-card border-l border-border z-100 transition-default ${isMobileOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'
          } ${isCollapsed ? 'w-20' : 'w-60'}`}
        dir="rtl"
      >
        <div className="sidebar-header flex items-center justify-center h-20 border-b border-border bg-primary bg-opacity-10 rounded-bl-xl transition-default">
          <div className={`sidebar-logo flex items-center justify-center transition-default ${isCollapsed ? 'w-10 h-10' : 'w-12 h-12'}`}>
            <Icon
              name="Layers"
              size={isCollapsed ? 24 : 32}
              color="var(--color-primary)"
              strokeWidth={2}
            />
          </div>
          {!isCollapsed && (
            <span className="mr-3 font-heading font-semibold text-xl text-primary transition-default">
              Dawayer
            </span>
          )}
        </div>

        <nav className="p-6 space-y-4">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              onClick={() => setIsMobileOpen(false)}
              className={`flex items-center justify-end h-12 px-4 rounded-lg transition-default hover:bg-muted hover:shadow-warm-sm ${isActive(item?.path)
                  ? 'bg-primary text-primary-foreground shadow-warm'
                  : 'text-foreground'
                }`}
              title={item?.tooltip}
            >
              {!isCollapsed && (
                <span className="flex-1 text-right font-body font-medium">
                  {item?.label}
                </span>
              )}
              <Icon
                name={item?.icon}
                size={20}
                color={isActive(item?.path) ? 'var(--color-primary-foreground)' : 'var(--color-foreground)'}
                strokeWidth={2}
                className="mr-3"
              />
            </Link>
          ))}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-border">
          <div className={`flex items-center justify-end ${isCollapsed ? 'justify-center' : ''}`}>
            {!isCollapsed && (
              <div className="text-right">
                <p className="text-sm font-caption text-muted-foreground">
                  آخر تحديث
                </p>
                <p className="text-xs font-data text-muted-foreground" dir="ltr">
                  20/01/2026 13:37
                </p>
              </div>
            )}
            <Icon
              name="Clock"
              size={20}
              color="var(--color-muted-foreground)"
              className={isCollapsed ? '' : 'mr-3'}
            />
          </div>
        </div>
      </aside>
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-background z-50 lg:hidden"
          onClick={toggleMobileMenu}
        />
      )}
    </>
  );
};

export default Sidebar;